<div mat-dialog-content>
  <div class="flex flex-col">
    <div class="flex flex-row pb-4">
      <button class="ml-auto" type="button" mat-button color="primary" (click)="exportPDF()">Export PDF</button>
    </div>
    <ng-container [ngTemplateOutlet]="contactsTemplate"
                  [ngTemplateOutletContext]="{export: false}"></ng-container>

    <button class="ml-auto" type="button" mat-button color="warn" (click)="close()">Close</button>
  </div>
</div>

<div class="print-outer">
  <div class="print-inner">
    <kendo-pdf-export #pdf [scale]="0.75" [forcePageBreak]="'.page-break'" [paperSize]="'A4'" margin="1cm">
      <ng-container [ngTemplateOutlet]="contactsTemplate"
                    [ngTemplateOutletContext]="{export: true}"></ng-container>
    </kendo-pdf-export>
    </div>
</div>

<ng-template #contactsTemplate let-export="export">
  <div class="pdf-document flex flex-col h-full gap-4">
    <div class="flex flex-row items-center">
      <img class="w-1/3 h-1/3" src="assets/images/OHA-Color.png" alt="Oregon Health Authority Logo">
    </div>
    <span class="font-semibold">Contacts for {{license.hospitalDBAName}} - {{license.licenseId}}</span>
    <hr class="w-full">
    <div class="flex flex-col gap-4">

      <div class="flex flex-col">
        <span><strong>Hospital Administrator</strong></span>
        <div class="flex flex-col md:flex-row md:gap-2">
          <div class="flex flex-col md:w-1/3">
            <span>{{license.hospitalAdminName}}</span>
          </div>
          <div class="flex flex-col md:w-1/3">
            <span>{{license.hospitalAdminEmail}}</span>
          </div>
          <div class="flex flex-col md:w-1/3">
            <span>{{license.hospitalAdminPhone | mask:'000 000-0000'}}</span>
          </div>
        </div>
      </div>

      <div class="flex flex-col">
        <span><strong>Emergency Contact</strong></span>
        <div class="flex flex-col md:flex-row md:gap-2">
          <div class="flex flex-col md:w-1/3">
            <span>{{license.emergencyContactName}}</span>
          </div>
          <div class="flex flex-col md:w-1/3">
            <span>{{license.emergencyContactEmail}}</span>
          </div>
          <div class="flex flex-col md:w-1/3">
            <span>{{license.emergencyContactPhone | mask:'000 000-0000'}}</span>
          </div>
        </div>
      </div>

      <div class="flex flex-col">
        <span><strong>Chief Nursing Officer/Nurse Executive</strong></span>
        <div class="flex flex-col md:flex-row md:gap-2">
          <div class="flex flex-col md:w-1/3">
            <span>{{license.chiefNurseName}}</span>
          </div>
          <div class="flex flex-col md:w-1/3">
            <span>{{license.chiefNurseEmail}}</span>
          </div>
          <div class="flex flex-col md:w-1/3">
            <span>{{license.chiefNursePhone | mask:'000 000-0000'}}</span>
          </div>
        </div>
      </div>

      <div class="flex flex-col">
        <span><strong>Person who filled out this application</strong></span>
        <div class="flex flex-col md:flex-row md:gap-2">
          <div class="flex flex-col md:w-1/3">
            <span>{{license.filerName}}</span>
          </div>
          <div class="flex flex-col md:w-1/3">
            <span>{{license.filerEmail}}</span>
          </div>
          <div class="flex flex-col md:w-1/3">
            <span>{{license.filerPhone | mask:'000 000-0000'}}</span>
          </div>
        </div>
      </div>

      <div class="flex flex-col">
        <span><strong>Emergency Department Director</strong></span>
        <div class="flex flex-col md:flex-row md:gap-2">
          <div class="flex flex-col md:w-1/3">
            <span>{{license.emergencyDepartmentDirectorName}}</span>
          </div>
          <div class="flex flex-col md:w-1/3">
            <span>{{license.emergencyDepartmentDirectorEmail}}</span>
          </div>
          <div class="flex flex-col md:w-1/3">
            <span>{{license.emergencyDepartmentDirectorPhone ?? '' | mask:'000 000-0000'}}</span>
          </div>
        </div>
      </div>

      <div class="flex flex-col">
        <span><strong>Professional/Technical Manager Co-Chair</strong></span>
        <div class="flex flex-col md:flex-row md:gap-2">
          <div class="flex flex-col md:w-1/3">
            <span>{{license.technicalManagerCoChairName}}</span>
          </div>
          <div class="flex flex-col md:w-1/3">
            <span>{{license.technicalManagerCoChairEmail}}</span>
          </div>
          <div class="flex flex-col md:w-1/3">
            <span>{{license.technicalManagerCoChairPhone ?? '' | mask:'000 000-0000'}}</span>
          </div>
        </div>
      </div>

      <div class="flex flex-col">
        <span><strong>Professional/Technical Staff Co-Chair</strong></span>
        <div class="flex flex-col md:flex-row md:gap-2">
          <div class="flex flex-col md:w-1/3">
            <span>{{license.technicalStaffCoChairName}}</span>
          </div>
          <div class="flex flex-col md:w-1/3">
            <span>{{license.technicalStaffCoChairEmail}}</span>
          </div>
          <div class="flex flex-col md:w-1/3">
            <span>{{license.technicalStaffCoChairPhone ?? '' | mask:'000 000-0000'}}</span>
          </div>
        </div>
      </div>

      <div class="flex flex-col">
        <span><strong>Service Staffing Committee Manager Co-Chair</strong></span>
        <div class="flex flex-col md:flex-row md:gap-2">
          <div class="flex flex-col md:w-1/3">
            <span>{{license.serviceStaffingCommitteeManagerCoChairName}}</span>
          </div>
          <div class="flex flex-col md:w-1/3">
            <span>{{license.serviceStaffingCommitteeManagerCoChairEmail}}</span>
          </div>
          <div class="flex flex-col md:w-1/3">
            <span>{{license.serviceStaffingCommitteeManagerCoChairPhone ?? '' | mask:'000 000-0000'}}</span>
          </div>
        </div>
      </div>

      <div class="flex flex-col">
        <span><strong>Service Staffing Committee Staff Co-Chair</strong></span>
        <div class="flex flex-col md:flex-row md:gap-2">
          <div class="flex flex-col md:w-1/3">
            <span>{{license.serviceStaffingCommitteeStaffCoChairName}}</span>
          </div>
          <div class="flex flex-col md:w-1/3">
            <span>{{license.serviceStaffingCommitteeStaffCoChairEmail}}</span>
          </div>
          <div class="flex flex-col md:w-1/3">
            <span>{{license.serviceStaffingCommitteeStaffCoChairPhone ?? '' | mask:'000 000-0000'}}</span>
          </div>
        </div>
      </div>

      <div class="flex flex-col">
        <span><strong>Nurse Manager Co-Chair</strong></span>
        <div class="flex flex-col md:flex-row md:gap-2">
          <div class="flex flex-col md:w-1/3">
            <span>{{license.nurseManagerName}}</span>
            <span>{{license.nurseManagerTitle}}</span>
          </div>
          <div class="flex flex-col md:w-1/3">
            <span>{{license.nurseManagerEmail}}</span>
          </div>
          <div class="flex flex-col md:w-1/3">
            <span>{{license.nurseManagerPhone ?? '' | mask:'000 000-0000'}}</span>
          </div>
        </div>
      </div>

      <div class="flex flex-col">
        <span><strong>Direct Care Co-Chair</strong></span>
        <div class="flex flex-col md:flex-row md:gap-2">
          <div class="flex flex-col md:w-1/3">
            <span>{{license.directCareName}}</span>
            <span>{{license.directCareTitle}}</span>
          </div>
          <div class="flex flex-col md:w-1/3">
              <span>{{license.directCareEmail}}</span>
          </div>
          <div class="flex flex-col md:w-1/3">
            <span>{{license.directCarePhone ?? '' | mask:'000 000-0000'}}</span>
          </div>
        </div>
      </div>

      <span><strong>Representative Contacts</strong></span>
      <div *ngFor="let rep of license.representativeContacts" class="flex flex-col md:flex-row md:gap-2">
        <div class="flex flex-col md:flex-row md:gap-2 w-full items-center">

          <div class="flex flex-col md:w-1/4">
            <span>{{rep.contactName}}</span>
          </div>

          <div class="flex flex-col md:w-1/4">
            <span>{{rep.contactPhone ?? '' | mask:'000 000-0000'}}</span>
          </div>

          <div class="flex flex-col md:w-1/4">
            <span>{{rep.contactEmail}}</span>
          </div>

          <div class="flex flex-col md:w-1/4">
            <div class="flex flex-row gap-2">
              <span><strong>Type:</strong></span>
              <span>{{rep.representativeType}}</span>
            </div>

            <div class="flex flex-row gap-2">
              <span><strong>Staff:</strong></span>
              <span>{{rep.representativeStaff}}</span>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div>
      <span>
        Printed on {{today | date}}.
      </span>
    </div>
  </div>
</ng-template>
